import config from "../../config.json";
import { reportApiError } from "../errors/presentError";
const BASE_AUTH_API = config.BASE_AUTH_API;

export const fetchLogsAPI = async (token, action, entityType, userId, page, LIMIT, signal) => {
    const params = new URLSearchParams({ page: String(page), limit: String(LIMIT) });
          if (action) params.set("action", action);
          if (entityType) params.set("entityType", entityType);
          if (userId) params.set("userId", userId);
    let responseData;
    try {
        await fetch(`${BASE_AUTH_API}logs?${params}`, {
            method: 'GET',
            headers: {
                Accept: 'application/form-data',
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
            },
            signal,
        }).then((response) => response.json()).then((data) => responseData = data);

        if (responseData.success) {
            return responseData
        }
        else {
            return
        }
    } catch (error) {
        // Aborts are intentional (filters changed / page left); let the caller ignore them.
        if (error.name === "AbortError") throw error
        reportApiError(error)
        return
    }
}